import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import './assets/style/index.css';
import moment from 'moment';
import '@/assets/icon/iconfont.css';
import '@/assets/icon/iconfont.js';
import Aegis from 'aegis-web-sdk';  //腾讯云 监控平台
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
// 中文文件
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import VueLazyload from 'vue-lazyload';
import '@/assets/style/theme.scss'   //  引入全局主题样式
// 视频插件
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-hls';
import axios from "axios";
// 引入axios
import $api from "./service/apiService";
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}
import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
// 获取内网 公网ip
let axiosNw = {
	data: ''
};
let axiosGw = {
	data: ''
};
const requestApi = async () => {
	axiosGw = await axios.get('https://api.ad-saas.com/check');
	if (['122.5.50.82\n', '111.198.26.107\n', '221.0.83.69\n', '114.242.4.18\n', '111.198.26.17\n', '114.242.4.112\n'].includes(axiosGw.data) && window.location.host !== 'dev-preview.alb.icuican.cn') {
		axiosNw = await axios.get('https://server.icuican.cn/check');
	}
};
if (window.requestIdleCallback) {
	requestIdleCallback(() => {
		// 选择哪些信息作为浏览器指纹生成的依据
		const options = {
			fonts: {
				extendedJsFonts: true,
			},
			excludes: {
				audio: true,
				userAgent: true,
				enumerateDevices: true,
				touchSupport: true,
				hasLiedOs: true,
				timezone: true
			},
		};
		// 浏览器指纹
		const fingerprint = Fingerprint2.get(options, async (components) => { // 参数只有回调函数或者options为{}时，默认浏览器指纹依据所有配置信息进行生成
			await requestApi();
			components.push({
				key:'nwip',
				value: axiosNw.data //通过接口获取的到ip
			});
			components.push({
				key:'gwip',
				value: axiosGw.data //通过接口获取的到ip
			});
			const values = components.map(component => component.value); // 配置的值的数组
			values.splice(19, 1);
			values.splice(17, 1);
			values.splice(3, 1);
			values.splice(3, 1);
			let userAgent = navigator.userAgent;  
			let language = navigator.language;  
			values[24] = userAgent;
			values[25] = language;
			values[26] = screen.width+screen.height;
			const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
			// console.log(components);
			// console.log(values);
			// console.log(murmur);
			localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
		});
	});
} else {
	setTimeout(() => {
		// 选择哪些信息作为浏览器指纹生成的依据
		const options = {
			fonts: {
				extendedJsFonts: true,
			},
			excludes: {
				audio: true,
				userAgent: true,
				enumerateDevices: true,
				touchSupport: true,
				hasLiedOs: true,
				timezone: true
			},
		};
		// 浏览器指纹
		const fingerprint = Fingerprint2.get(options, async (components) => { // 参数只有回调函数或者options为{}时，默认浏览器指纹依据所有配置信息进行生成
			await requestApi();
			components.push({
				key:'nwip',
				value: axiosNw.data //通过接口获取的到ip
			});
			components.push({
				key:'gwip',
				value: axiosGw.data //通过接口获取的到ip
			});
			const values = components.map(component => component.value); // 配置的值的数组
			values.splice(19, 1);
			values.splice(17, 1);
			values.splice(3, 1);
			values.splice(3, 1);
			let userAgent = navigator.userAgent;  
			let language = navigator.language;  
			values[24] = userAgent;
			values[25] = language;
			values[26] = screen.width+screen.height;
			const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
			// console.log(components);
			// console.log(values);
			// console.log(murmur);
			localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
		});
	}, 500);
}

if(process.env.VUE_APP_KEY == 'production'){
// 腾讯云前端监控-错误上报  
const aegis = new Aegis({
	id: 'Yr5wWhbWYR3ka7DXWJ', // 上报 id
	env:process.env.VUE_APP_KEY,
	uin: "ALB-LIVE", // 用户唯一 ID（可选） 后端校验规则 /^[@=.0-9a-zA-Z_-]{4,36}$/
	reportApiSpeed: true, // 接口测速
	reportAssetSpeed: true, // 静态资源测速
	spa: true, // spa 应用页面跳转的时候开启 pv 计算
	hostUrl: "https://rumt-zh.com",
	api: {
		reportRequest: true, // 接口全量上报，info 对全部用户生效
		apiDetail: true, // 上报接口的同时，也会上报接口请求参数和返回值
	},
});


// Aegis 项目代码上报
app.config.errorHandler = function (err, vm, info) {
  aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
};
window.addEventListener("unhandledrejection", (event) => {
  aegis.error(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
});
}

// 全局挂载api
app.config.globalProperties.$api = $api;
// 视频
app.use(VideoPlayer);
// 时间组件
app.config.globalProperties.$moment = moment;
// 页面按钮权限指令
app.directive('btnPermissions', {
	beforeMount (el, binding, vnode) {
		const { value } = binding;
		// 获取meta中的权限
		// 获取创建的按钮池,在meta中找不到在这个池子中找，解决按钮在不知名的页面下问题；
		const btnPermissionList = JSON.parse(
			localStorage.getItem('qcBtnPermissionList')
		) || [];
		// console.log(btnPermissionList);
		if (value && value instanceof Array && value.length > 0) {
			const hasPermission = btnPermissionList.some(role => {
				return value.includes(role);
			});
			if (!hasPermission) {
				el.style = 'display:none';
				// el.parentNode && el.parentNode.removeChild(el)
			}
		}
	}
});
// 页面按钮权限指令
app.directive('btn', {
	beforeMount (el, binding, vnode) {
		const { value } = binding;
		// 获取meta中的权限
		// 获取创建的按钮池,在meta中找不到在这个池子中找，解决按钮在不知名的页面下问题；
		const btnPermissionList = JSON.parse(
			localStorage.getItem('qcBtnPermissionList')
		) || [];
		// console.log(btnPermissionList);
		if (value && value instanceof Array && value.length > 0) {
			const hasPermission = btnPermissionList.some(role => {
				return value.includes(role);
			});
			if (!hasPermission) {
				el.style = 'display:none';
				// el.parentNode && el.parentNode.removeChild(el)
			}
		}
	}
});
// 图片懒加载
app.use(VueLazyload, {
	preLoad: 1.3,
	// error: '//cdn.hsuanyuen.com/Fe-public/adsaas-file/img-error-icon.gif',
	error: '//cdn.hsuanyuen.com/Fe-public/adsaas-file/loading.svg',
	loading: '//cdn.hsuanyuen.com/Fe-public/adsaas-file/loading.svg',
	attempt: 1
});
app.use(ElementPlus, {locale: zhCn});
app.use(store).use(router).mount("#app");
